import { Link } from "react-router-dom";

function NotFound() {
    return(
        <div className="not-found">
            <div>You are at the wrong page and you don't know, it's not a big deal, but what if your team is at the wrong page?</div>
            <Link to='/'>
                <div><button><h3>Visit the right page</h3></button></div>
            </Link>
            <div className="watermark">
                404 Not Found
            </div>
        </div>
    )
}

export default NotFound;